export enum CompletionStatus {
  None = 0,
  Requested = 1,
  Completed = 2,
}
